<template>
  <DoubleColumn v-if="context">
    <template #header>
      <PodcastHeader :podcast="context" />
    </template>
    <template #left>
      <SetupWidget :podcast="context" />
      <ExperimentWidget :podcast="context"/>
      <EstimationWidget :podcast="context" />
      <TrialWidget :podcast="context" />
      <BookmarkWidget :podcast="context"/>
      <br/>
      <AppliedBullets :podcast="context" />
    </template>
    <template #right>
      <PresentWidget :podcast="context" />
      <SubscribeWidget :podcast="context" />
      <ObjectiveWidget :podcast="context" />
      <AdviceWidget :podcast="context" />
      <StrategyWidget :podcast="context" />
      <CoworkerWidget :podcast="context" />
    </template>
  </DoubleColumn>
  <SingleColumn v-else="context">
    <template #header>
      <h1 class="text-3xl font-bold text-white">
        Podcast
      </h1>
    </template>
    <template #content>
      <section>
        <div class="bg-white shadow overflow-hidden sm:rounded-lg">
          <div class="px-4 py-5 sm:px-6">
            <Onboarding>
              Du hast noch kein Podcast-Format auf St. Audio.
            </Onboarding>
          </div>
        </div>
      </section>
    </template>
  </SingleColumn>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const context = computed(() => store.getters['context/context']);
</script>
